/**
 * web-client-app D5 — the boot block the server writes into every website page:
 * the studio's public profile (so the header and hero draw without a request)
 * and whether the server answered this address with 404.
 */
import type { SiteStudioDto } from '@telify/shared';

export interface WebBoot {
  readonly studio: SiteStudioDto;
  readonly notFound: boolean;
}

let cached: WebBoot | null | undefined;

export function readBoot(): WebBoot | null {
  if (cached !== undefined) return cached;
  try {
    const el = typeof document !== 'undefined' ? document.getElementById('telify-web-boot') : null;
    cached = el?.textContent ? (JSON.parse(el.textContent) as WebBoot) : null;
  } catch {
    cached = null;
  }
  return cached;
}

/** Test seam. */
export function resetBootForTests(boot: WebBoot | null | undefined = undefined): void {
  cached = boot;
}
